import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-section-badge',
  templateUrl: './section-badge.component.html',
  styleUrls: ['./section-badge.component.scss']
})
export class SectionBadgeComponent {
  @Input() label = '';
  @Input() icon?: string;
}
